(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mensch-vip-topbar"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__menschVipTopbar) return;
    const container = document.getElementById('mensch-vip-topbar');
    if (!container) return;
    const bar = container.querySelector('.mensch-vip-topbar');
    const button = container.querySelector('.mensch-vip-topbar__copy');
    const status = container.querySelector('[data-mensch-vip-status]');
    const copyLabel = button.querySelector('[data-mensch-vip-copy-label]');
    const closeButton = container.querySelector('.mensch-vip-topbar__close');
    const header = document.querySelector('.section-header');
    if (header) header.after(container);
    const { coupon, customerKey, returningCustomer } = container.dataset;
    const sessionKey = 'mensch:vip-topbar:v1';
    const forms = new Map();
    const dismissedKey = 'mensch:vip-topbar-dismissed:v1';
    let dismissed = false;
    let measureFrame;
    try { dismissed = sessionStorage.getItem(dismissedKey) === coupon; } catch {}
    let record = null;
    let timer;
    let copyTimer;
    let widget;
    let widgetObserver;

    try { record = JSON.parse(sessionStorage.getItem(sessionKey) || 'null'); } catch {}

    function eligible() {
      return returningCustomer !== 'true' && record?.version === 1 &&
        record.coupon === coupon && record.customerKey === customerKey && Boolean(record.sourceId);
    }

    function measure() {
      if (container.hidden) return;
      const top = `${Math.max(0, Math.round(header?.getBoundingClientRect().bottom || 0))}px`;
      if (container.style.getPropertyValue('--mensch-vip-topbar-top') !== top) container.style.setProperty('--mensch-vip-topbar-top', top);
    }

    function render() {
      const visible = Boolean(eligible()) && !dismissed;
      container.hidden = !visible;
      if (visible) measure();
    }

    function confirm(sourceId) {
      if (returningCustomer === 'true') return;
      record = { version: 1, coupon, customerKey, sourceId };
      try { sessionStorage.setItem(sessionKey, JSON.stringify(record)); } catch {}
      render();
    }

    function inspectEcomSend() {
      const cookies = new Map();
      try {
        document.cookie.split(';').forEach(entry => {
          const index = entry.indexOf('=');
          if (index < 0) return;
          try { cookies.set(entry.slice(0, index).trim(), decodeURIComponent(entry.slice(index + 1))); } catch {}
        });
      } catch {}
      for (const [name, value] of cookies) {
        const match = /^ecomsend_pp_success_subscribed(\d+)$/.exec(name);
        if (match && value === 'true' && cookies.get(`ecomsend_discount_code${match[1]}`) === coupon) {
          confirm(`ecomsend:${match[1]}`);
          return;
        }
      }
    }

    function inspectForm(state) {
      if (!state.submitted) return;
      const success = state.root.querySelector('#app-embed[data-current-step="success"]');
      if (!success || !success.textContent.split(/\W+/).includes(coupon)) return;
      state.submitted = false;
      confirm(`shopify-forms:${state.id}`);
    }

    function bindForms() {
      forms.forEach((state, host) => {
        if (host.isConnected) return;
        state.observer.disconnect();
        state.root.removeEventListener('submit', state.onSubmit, true);
        forms.delete(host);
      });
      document.querySelectorAll('shopify-forms-embed[id^="app-embed-container-"]').forEach(host => {
        if (forms.has(host) || !host.shadowRoot) return;
        const state = { root: host.shadowRoot, id: host.id, submitted: false };
        state.onSubmit = event => {
          if (event.target?.tagName === 'FORM') state.submitted = true;
        };
        state.observer = new MutationObserver(() => inspectForm(state));
        state.root.addEventListener('submit', state.onSubmit, true);
        state.observer.observe(state.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-current-step'] });
        forms.set(host, state);
      });
    }

    function refresh() {
      clearTimeout(timer);
      if (document.hidden) return;
      if (returningCustomer === 'true') {
        record = null;
        try { sessionStorage.removeItem(sessionKey); } catch {}
        render();
        return;
      }
      if (!eligible()) {
        inspectEcomSend();
        bindForms();
        forms.forEach(inspectForm);
      }
      render();
      if (eligible()) {
        widgetObserver?.disconnect();
        return;
      }
      const nextWidget = document.getElementById('ecomsend-widget');
      if (widget !== nextWidget) {
        widgetObserver?.disconnect();
        widget = nextWidget;
        if (widget) {
          widgetObserver = new MutationObserver(inspectEcomSend);
          widgetObserver.observe(widget, { childList: true, subtree: true });
        }
      }
      timer = setTimeout(refresh, 1500);
    }

    function fallbackCopy() {
      const field = document.createElement('textarea');
      field.value = coupon;
      field.readOnly = true;
      field.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;margin:0;padding:0;border:0;font-size:16px;opacity:0;pointer-events:none';
      bar.appendChild(field);
      field.select();
      let copied = false;
      try { copied = document.execCommand('copy'); } catch {}
      field.remove();
      button.focus({ preventScroll: true });
      return copied;
    }

    button.addEventListener('click', async () => {
      clearTimeout(copyTimer);
      let copied = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(coupon);
          copied = true;
        } else copied = fallbackCopy();
      } catch { copied = fallbackCopy(); }
      copyLabel.textContent = copied ? button.dataset.copiedText : button.dataset.copyText;
      button.toggleAttribute('data-copied', copied);
      status.textContent = copied ? button.dataset.copiedText : button.dataset.errorText;
      copyTimer = setTimeout(() => {
        copyLabel.textContent = button.dataset.copyText;
        button.removeAttribute('data-copied');
        status.textContent = '';
      }, 2500);
    });

    closeButton.addEventListener('click', () => {
      dismissed = true;
      try { sessionStorage.setItem(dismissedKey, coupon); } catch {}
      render();
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(measure);
      observer.observe(bar);
      if (header) observer.observe(header);
    }
    else window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('scroll', () => {
      if (container.hidden || measureFrame) return;
      measureFrame = requestAnimationFrame(() => { measureFrame = null; measure(); });
    }, { passive: true });
    window.addEventListener('pageshow', refresh);
    window.addEventListener('pagehide', () => clearTimeout(timer));
    document.addEventListener('visibilitychange', refresh);
    window.__menschVipTopbar = { refresh, isEligible: () => Boolean(eligible()) };
    refresh();
  })();
  } catch(e) { console.error(e); }
})();

})();
